export const TOGGLE = {
  INTERCOM: 'toggle-intercom',
};
